import { useState } from 'react';

export function useDashboardModals() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [suggestionsOpen, setSuggestionsOpen] = useState(false);
  const [exportOpen, setExportOpen] = useState(false);
  const [customizeOpen, setCustomizeOpen] = useState(false);
  const [velaCleanupOpen, setVelaCleanupOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);

  return {
    drawerOpen,
    setDrawerOpen,
    suggestionsOpen,
    setSuggestionsOpen,
    exportOpen,
    setExportOpen,
    customizeOpen,
    setCustomizeOpen,
    velaCleanupOpen,
    setVelaCleanupOpen,
    importOpen,
    setImportOpen,
  };
}